import { Component, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ApiVersion } from 'app/shared/models/apiVersion';
import { ApiVersionService } from 'app/shared/services/apiVersion.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnInit {

  public apiVersion: ApiVersion;
  public deploymentInfoVisible = false;
  public readonly webCommitId = '[[WEB_COMMIT_ID]]';
  public readonly webDeploymentDate = '[[WEB_DEPLOYMENT_DATE_TIME]]';

  constructor(public auth: AuthService, private apiVersionService: ApiVersionService) {
  }

  ngOnInit() {
    this.apiVersionService.getApiVersion().subscribe({
      next: (apiVersion) => this.apiVersion = apiVersion,
      error: () => this.apiVersion = null,
    });
  }

  toggleDeploymentInfo() {
    this.deploymentInfoVisible = !this.deploymentInfoVisible;
  }

  getLastUpdated(apiVersion?: ApiVersion): string {
    const validDates = [
      this.webDeploymentDate,
      apiVersion ? apiVersion.apiDeploymentDate : null,
    ].filter((date) => this.isDeploymentTimestamp(date)) as string[];

    if (validDates.length === 0) {
      return '';
    }

    return this.formatDeploymentTimestamp(validDates.sort().reverse()[0]);
  }

  formatDeploymentTimestamp(value?: string | null): string {
    if (!this.isDeploymentTimestamp(value)) {
      return value || '';
    }

    const [year, month, day, hour, minute, second] = value.split('-');
    return `${day}.${month}.${year}. ${hour}:${minute}:${second}`;
  }

  private isDeploymentTimestamp(value?: string | null): boolean {
    return !!value && /^\d{4}-\d{2}-\d{2}-\d{2}-\d{2}-\d{2}$/.test(value);
  }

}
